export default {
  'common.ReLogin': '重新登录',
  'common.ChangePassword': '修改密码',
  'common.Logout': '登出',
  'common.LoginStatusInvalid': '登录状态已失效，请重新登录！',
  'common.BackHome': '返回首页',
  'message.HTTP_403': '抱歉，您无权访问此页面。',
  'message.HTTP_404': '抱歉，您访问的页面不存在。',

  '+FDO1E': '入驻联系人邮箱',
  '/XxWUC': '自有海外仓直接填写自有海外仓，如没有，填写“无”',
  '/q5fD8': '是否在英国/东南亚本地有海外仓',
  '01n1lw': '该品牌是否已在德国当地拥有R标',
  '0sn8j/': '请填写姓名',
  '1wOLiI': '做独立站意向',
  '2cyTCk': '已提交(需等待 {day1} 个工作日) ——> 初筛通过已同步提交给平台(需等待 {day2} 个工作日) ——> 平台通过',
  '2towDA': '美国站近一年销售额(USD)',
  '387HdI': '是否有自建海外仓或第三方海外仓',
  '3K1yMY': '库内监控材料',
  '49iOzF': '企业/品牌类型',
  '4L3xFT': '公司规模（员工数量）',
  '5grmob': '请填写邮箱',
  '5rJPKe': '希望开通ManoMano的国家站点',
  '6C4ze5': '主要产品类目',
  '6jglbI': '品牌商标注册地',
  '6nYN2s': '请选择是否有自建海外仓或第三方海外仓',
  '6udigR': '公司性质',
  '7V8auA': '单品牌全渠道近一年的销售额(USD)',
  '7gK7Rj': '在经营中的店铺最近一季度平均月销售额(USD)',
  '7wp+GP': '其它电商平台单站点单账号近一年的销售额(USD)',
  '85GJe2': '账号负责人电话',
  '8xAjhV': '卖家联系人信息',
  '9aEF/T': '店铺货源',
  '9bKiBE': '请务必确保邮箱可以接收邮件，发放注册链接',
  'A3JVko': '营业执照公司名称',
  'AyGOuG': '亚马逊德国、eBay德国、Kaufland 或其他平台店铺/独立站后台截图',
  'B4jhFM': '账号注册用邮箱',
  'BZ219V': '请填写中文名称',
  'BgUDFC': '入驻状态',
  'D6nMUK': '主营类目',
  'DU8pzO': '请填写公司法定名称',
  'DcPRut': '请填写您常用的QQ号',
  'DhEqZS': '您的微信号',
  'E92Gy6': '新增链接',
  'EL4b8j': '请填写其它北美电商平台的“店铺”链接',
  'EPp062': '德国公司名',
  'Ems0C9': '如有，请填写海外仓服务商名',
  'EoXCE9': '业务模式',
  'F+ij7Y': '是否已办理该德国公司的VAT',
  'FPYNcH': '请填写1到11位数字',
  'GzrOsm': '申请的二级类目',
  'H26cpN': '20字以上，150字以内',
  'Hh+8lr': '填写您目前主营产品类目',
  'IcnW+V': '其它北美电商平台的“店铺”链接',
  'InYzo7': '您计划是做英国市场还是东南亚市场',
  'Iv0cZc': '法人国籍',
  'JonMgV': 'SKU数量',
  'JzufF9': '您常用的QQ号',
  'KIfH+Q': '请填写20到150位任意字符',
  'KQOzSw': '电子邮箱',
  'KqTHNC': '库内截图',
  'L4jOeD': '填写主营的具体二级类目',
  'LxjC12': 'QQ号',
  'MdKKAC': '其它电商平台的店铺链接',
  'NG02nv': '公司所在区域',
  'NuSU2V': '中文填写',
  'Nwgq9f': '是否拥有德国当地海外仓',
  'OOfHj5': '法人姓名',
  'Ot/X5z': '入驻联系人信息',
  'P6ktCt': '填写中文名',
  'P8S+b1': '是否有德语客服人员',
  'R4mfIu': '例如，亚马逊店铺/速卖通店铺/天猫/京东/独立站优先，或其他',
  'SNeIpX': '亚马逊欧洲站, Allegro, Fnac/darty 等等',
  'U3/OiC': '其它欧洲电商平台店铺链接',
  'Uo35I9': '点击视频链接打开视频（只有已申请查询并获取视频的单据有库内视频信息，超期文件无法打开',
  'VFVI+w': '填写具体金额',
  'VwT6Ym': '请填写金额',
  'WIRiiO': '主营产品（具体二级类目）',
  'WXHb1+': '请务必保持电话畅通，将作为后续主要联络方式',
  'X+Zymb': '公司简介或者罗列出公司的优势',
  'XEsuFF': '请填写主营产品',
  'XXh7Kw': '营业执照中文名称',
  'XwN70f': '请填写亚马逊德国, eBay德国, Kaufland,或者其他平台店铺/独立站链接',
  'Y0L01Z': '正在运营的欧美跨境电商平台链接',
  'YI7fqG': '第三方平台链接',
  'Z1d1dA': '入驻品牌名',
  'ZcMSoa': '请填写营业执照公司名称',
  'aIq9ik': '其它（eBay、Amazon）北美电商平台单站点单账号近一年的销售额(USD)',
  'aidSjp': '点击截图链接下载文件（只有已申请查询并获取视频的单据有库内截图信息，超期文件无法打开）',
  'bN8SdN': '企业/品牌简介',
  'bNQ47y': '重新编辑',
  'bilPnX': '公司主营产品',
  'c9DIEs': '填写英文或汉语拼音 例：中- Zhang San or 英- Rachel Green',
  'crZAUj': '申请人QQ号',
  'csAYl3': '电子产品类目必须填写是否有Weee',
  'd+drZB': '如果有 请填写 将有机会对接引流项目',
  'fqBdzm': '公司法定名称',
  'gGYhmd': '账号负责人姓名',
  'gKaGa2': '填写美国站销售平台（是否有亚马逊/沃尔玛/独立站）',
  'gP+ldf': '入驻联系人姓名',
  'gVUjRH': '请务必确保电话畅通',
  'gqZa18': '中国公司办地址',
  'hC7WeL': '企业/品牌官网',
  'i2HQKK': '入驻联系人电话',
  'i8orsr': '销售额',
  'iTutLd': '您拥有的品牌名称',
  'jJeioA': '法人',
  'k0TWda': '正在使用的独立站平台',
  'kUTW+Q': '申请人电话',
  'l+0j0U': '以上电商平台过去30天销售额',
  'lC0TIO': '请填写具体金额',
  'lCo8xA': '请填写1到20位数字',
  'm8yqtX': '请填写微信号',
  'mkiqo/': '中国公司名',
  'nVPQ6u': 'Shopify独立站网址',
  'nbGLjI': '库内视频',
  'oFGnIc': '中国公司的营业执照{break}德国公司的营业执照{break}法人手持护照和身份证的拍照件{break}德国当地海外仓的发货证明{break}德语客服人员的德语证书',
  'pKBw1k': '{platform} 入驻申请',
  'pb7ufS': '账号负责人邮箱',
  'pe5tUK': '美国站销售平台',
  'pnPqSu': '公司全名',
  'q9+Dhh': '请填写注册邮箱',
  'qDJlru': '客单价 (USD)',
  'qDga7W': '您距离入驻成功需要等多久：',
  'qjVIUB': '海外仓服务商名称',
  's7Ufrr': '是否有直播/短视频运营经验',
  'u1sMF4': '请提供证件并打包发送',
  'u6/UxW': '请提供以下证件并打包发送',
  'udZJ3q': '只填数字，不需要货币符号',
  'uqYkNh': '如没有操作过其他平台 填“否”，如有请填写具体金额',
  'v725h2': '请填写电话',
  'v8b14F': '请填写联系人姓名',
  'vc/KMI': '立即入驻',
  'w+7yLR': '跨境电商近一年销售额(USD)',
  'w6hWi5': '账号负责人微信',
  'x6NFpn': '客户单价 (USD)',
  'xToKvz': 'TikTok账号名称（没有请填无）',
  'yMUv2D': '请填写1到60位任意字符',
  'q1fRx5': '亚马逊德国，eBay德国，Kaufland等店铺的后台销售截图',
  '3/Oz1Q': '订单：【{orderIds}】为平台面单发货，不允许合单',
  '4HJ+hu': '不同步库存',
  '6M9rWS': '查看未发货订单',
  'Boxv3o': '平台仓库id',
  'Bpo42k': '万邑通仓库',
  'Cp9jJx': '请输入1~100的正整数',
  'D+aqEf': '请输入0~1000000的正整数',
  'Fx2qpm': 'Tiktok平台数据授权与免责协议',
  'Hd8vWP': '仓库库存数量 X',
  'JXyArZ': '仓库匹配',
  'PAK8Nq': '阅读并同意',
  'PaIEXA': '同步仓库实际库存',
  'RI3DFS': '确认签署',
  'SQfl8g': '《TikTok平台面单免责协议》',
  'V7Hm5N': '安全库存设置',
  'VKrL6o': '物流成本最优',
  'ZFAL2b': 'Tiktok平台面单出库的订单，不使用选择的发货方式，以平台提供的发货方式为准。',
  'bGcjx4': '库存同步数量',
  'cZA4KD': '同步固定值',
  'gBPBiQ': '目前仅支持 eBay、eBay eF、Temu、AliExpress、Shopify、Shein、Amazon(MSF)、Tiktok平台配置规则。其余平台将陆续开放，敬请期待!',
  'ie/swL': '确定重试吗？',
  'kMFVJj': '物流时效最优',
  'pR5Kts': '重试',
  'qUjxg7': '平台面单物流服务',
  'qvnXLa': '平台面单类型订单和普通订单不允许批量发货',
  'rbvotq': '当库存推送数小于等于',
  'sZjg8x': '订单产品不一致，不允许批量操作',
  'uLJq8F': '临界库存同步',
  '+7V2pl': '共',
  '/1JAw2': '英文品名',
  '8970ZG': 'Winit计费产品',
  '9SA/lA': '出库信息',
  'GZcPC1': '返回主信息',
  'QkwbXX': '(*以下时间取操作地点当地时区)',
  'fD8+70': '条记录',
  'fGrEYv': '收件人Email',
  'yF/N68': '验证码校验失败',
};
